import React, { useState } from 'react'
import SbEditable from 'storyblok-react'
import RichText from 'src/utils/RichText'
import Heading from 'src/components/Heading'
import Label from 'src/components/Label'
import FluidImage from 'src/utils/FluidImage'
import Button from 'src/components/Button'
import Wave from 'src/utils/Wave';
import Slider from "react-slick";
import { BackgroundColour, FillColour } from 'src/utils/ColourUtilities';
import { Link } from 'gatsby'
import resolveLink from 'src/utils/resolveLink'

const PrevArrow = props => {
    const { onClick } = props
    return (
        <div
            className={'group h-11 w-11 bg-blue hover:bg-teal duration-300 md:flex hidden items-center justify-center rounded-full absolute lg:left-[10px] md:left-[10px] left-[10px] top-[35%] z-10'}
            onClick={onClick}
            onKeyDown={onClick}
            role="button"
            tabIndex={0}
        >
            <i className="fa-solid fa-chevron-left text-white duration-300"></i>
        </div>
    );
};

const NextArrow = props => {
    const { onClick } = props
    return (
        <div
            className={'group h-11 w-11 bg-blue hover:bg-teal duration-300 md:flex hidden items-center justify-center rounded-full absolute lg:right-[10px] md:right-[10px] right-[10px] top-[35%] z-10'}
            onClick={onClick}
            onKeyDown={onClick}
            role="button"
            tabIndex={0}
        >
            <i className="fa-solid fa-chevron-right text-white duration-300"></i>
        </div>
    );
};

const SplitWithImagesSlider = ({ blok }) => {

    // Replicated from HERO
    // Setting up a synthetic click of the dots because they are way too hard to position properly
    const [activeSlide, setActiveSlide] = useState(0)
    const OnClick = (index) => {
        // Target the slick dots LI and click the proper one depending on INDEX
        const target = document.getElementsByClassName(`slick-dots-${blok._uid}`)[0].getElementsByTagName("li")
        const indexLogic = index > (blok.slides.length-1) ? 0 : index < 0 ? blok.slides.length-1 : index
        target[indexLogic].getElementsByTagName("button")[0].click()
    }

    const settings = {
        dots: true,
        fade: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 8000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dotsClass: `slick-dots slick-dots-${blok._uid} !hidden`,
        beforeChange: (current, next) => setActiveSlide(next),
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        };
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="relative">
                <div className={`bg-white overflow-hidden`}>
                    <div className={`max-w-7xl mx-auto px-6 pt-14 lg:pt-20 flex flex-col items-center 2xl:max-w-screen-2xl`}>
                        <Label className="text-teal mb-4">{blok.label}</Label>
                        <Heading size="h3" className="max-w-lg text-center">{blok.title}</Heading>
                    </div>
                    <Slider {...settings} className="pb-14 lg:pb-20 !select-auto">
                        {blok.slides?.map((slide, index) => (
                            <>
                                <div className={`w-full test ${BackgroundColour(slide.colour)}`}>
                                    <div className="max-w-7xl mx-auto relative md:px-16 px-6 py-16 flex flex-col justify-center items-start h-full gap-4 2xl:max-w-screen-2xl">
                                        <div className="flex md:flex-row flex-col md:justify-center md:items-center gap-12 w-full">
                                            <div className="z-10 flex flex-col items-start md:w-1/2">
                                                <Heading size="h4" className="text-blue">{slide.title}</Heading>
                                                <div className="text-blue md:max-w-md lg:text-base text-sm tracking-[-0.01em] prose">
                                                    <RichText>{slide.description}</RichText>
                                                </div>
                                                {slide.button_text && 
                                                    <Button to={slide.button_target?.cached_url} className="bg-blue hover:bg-darkblue mt-6">{slide.button_text}</Button>
                                                }
                                            </div>
                                            <div className="md:w-1/2 w-full relative md:block hidden">
                                                { slide.button_target?.cached_url && 
                                                <Link className="block absolute left-0 top-0 w-full h-full z-10" to={resolveLink(slide.button_target?.cached_url)}></Link> }
                                                <div className={`w-full h-full relative md:max-w-none max-w-lg mx-auto`}>
                                                    <FluidImage
                                                    className="w-full h-full"
                                                    image={slide.image}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:hidden flex flex-row justify-center items-center z-40">
                                        <div
                                            className={'group h-8 w-8 bg-blue hover:bg-teal duration-300 flex items-center justify-center rounded-full z-10 mr-2'}
                                            onClick={() => OnClick(index-1)}
                                            onKeyPress={() => OnClick(index-1)}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            <i className="fa-solid fa-chevron-left text-white duration-300 text-sm"></i>
                                        </div>
                                        {blok.slides?.map((slide, index) => (
                                            <div 
                                                onClick={() => OnClick(index)} 
                                                onKeyPress={() => OnClick(index)}
                                                role="button"
                                                tabIndex="0" 
                                                className={`cursor-pointer py-1 px-2 group z-10`}>
                                                    <span className={`block group-hover:text-white rounded-full duration-300 ${index === activeSlide ? 'text-white' : 'text-blue'}`}>{index+1}</span>
                                            </div>
                                        ))}
                                        <div
                                            className={'group h-8 w-8 bg-blue hover:bg-teal duration-300 flex items-center justify-center rounded-full z-10 ml-2'}
                                            onClick={() => OnClick(index+1)}
                                            onKeyPress={() => OnClick(index+1)}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            <i className="fa-solid fa-chevron-right text-white duration-300 text-sm"></i>
                                        </div>
                                    </div>
                                </div>
                                <Wave size="small" className={`${FillColour(slide.colour)}`}/>
                            </>
                        ))}
                    </Slider>
                </div>
            </div>
        </SbEditable>
    )
}

export default SplitWithImagesSlider